const adTagJsScript = `<script>
    {
        "token": "PUBLISHER_TOKEN",
        "url": "AD_SERVER_URL",
        "bids": [
            {
                "placementId": "placementId",
                "bidFloor": "bidFloor",
                "impMediaType": "mediaType",
                "width": "width",
                "height": "height"
            }
        ]
    }
</script>`;

export default adTagJsScript;
